<script>
	import { marked } from 'marked';

	export let title;
	export let content;
</script>

<svelte:head>
	<title>{title} - 단비데스크</title>
</svelte:head>

<div class="min-h-screen bg-gray-100 py-12 px-4">
	<div class="max-w-3xl mx-auto">
		<div class="legal-content bg-white rounded-xl shadow-lg p-8">
			{@html marked(content)}
		</div>
	</div>
</div>

<style>
	:global(.legal-content h1) {
		font-size: 1.5rem;
		font-weight: 700;
		color: #111827;
		margin-bottom: 1.5rem;
	}

	:global(.legal-content h2) {
		font-size: 1.125rem;
		font-weight: 700;
		color: #111827;
		margin-top: 1.5rem;
		margin-bottom: 0.75rem;
	}

	:global(.legal-content h3) {
		font-size: 1rem;
		font-weight: 600;
		color: #1f2937;
		margin-top: 1rem;
		margin-bottom: 0.5rem;
	}

	:global(.legal-content p) {
		color: #374151;
		font-size: 0.9375rem;
		line-height: 1.7;
		margin-bottom: 0.75rem;
	}

	:global(.legal-content ul) {
		margin-top: 0.25rem;
		margin-bottom: 0.75rem;
		padding-left: 1.25rem;
		list-style-type: disc;
	}

	:global(.legal-content li) {
		color: #374151;
		font-size: 0.9375rem;
		line-height: 1.7;
		margin-bottom: 0.25rem;
	}

	:global(.legal-content strong) {
		font-weight: 600;
		color: #111827;
	}

	:global(.legal-content blockquote) {
		border-left: 3px solid #3b82f6;
		background-color: #eff6ff;
		padding: 0.75rem 1rem;
		margin: 0.75rem 0;
		border-radius: 0 0.5rem 0.5rem 0;
		color: #1e40af;
	}

	:global(.legal-content blockquote p) {
		margin-bottom: 0;
	}

	:global(.legal-content table) {
		width: 100%;
		border-collapse: collapse;
		margin: 0.75rem 0;
		font-size: 0.875rem;
	}

	:global(.legal-content th) {
		background-color: #f3f4f6;
		font-weight: 600;
		text-align: left;
		padding: 0.5rem 0.75rem;
		border-bottom: 2px solid #e5e7eb;
		color: #374151;
	}

	:global(.legal-content td) {
		padding: 0.5rem 0.75rem;
		border-bottom: 1px solid #f3f4f6;
		color: #374151;
	}

	:global(.legal-content tr:hover td) {
		background-color: #f9fafb;
	}

	:global(.legal-content a) {
		color: #2563eb;
		text-decoration: underline;
		text-underline-offset: 2px;
	}

	:global(.legal-content a:hover) {
		color: #1d4ed8;
	}

	:global(.legal-content hr) {
		border: none;
		border-top: 1px solid #e5e7eb;
		margin: 1.5rem 0;
	}
</style>
